<template>
  <div>Gestao Cadastros</div>
</template>

<script>
export default {}
</script>

<style></style>
